import {
  Box,
  type Palette,
  type PaletteColor,
  type SxProps,
} from '@mui/material'
import type { GridRenderCellParams } from '@mui/x-data-grid'

type ThemeColor =
  | {
      [K in keyof Palette]: Palette[K] extends PaletteColor ? K : never
    }[keyof Palette]
  | ({} & string)

type Props = {
  color?: ThemeColor
  sx?: SxProps
} & GridRenderCellParams

export const StatusCell = (props: Props) => {
  const { formattedValue, color } = props

  return (
    <Box
      sx={{
        color: `${color}.main`,
        '::selection': {
          color: `${color}.contrastText`,
          bgcolor: `${color}.main`,
        },
        ...props.sx,
      }}
    >
      <span>{formattedValue}</span>
    </Box>
  )
}
